import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Button,  Header,  Segment } from "semantic-ui-react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import { useField } from "formik";
import * as Yup from 'yup';
import MyTextInput from "../../app/common/form/MyTextInput";
import MyDateInput from "../../app/common/form/MyDateInput";
import {MySelectInput, valor, MySelectInputEdiciones} from "../../app/common/form/MySelectInput";
import { toast, ToastContainer } from 'react-toastify';
import { CuotasMod, CuotasModFormValues } from "../../app/models/CuotasMod";
import { TiposCuentas } from "../../app/common/options/TiposCuentas";
import { createCATCursos } from "../../app/models/CATCursos";
import { number } from "yup/lib/locale";
import { Check } from "@material-ui/icons";


export default observer(function CreateOperacion() {
        
    const [condicion, setCondicion] = useState(false)
    const history = useHistory();
    const [aplica, setAplica]=useState(false);


    const {CuotasStore, modalStore} = useStore();    

    const {createCuotasMod, loading, } = CuotasStore;
    //const {CATCoursesInfo,testing} = CuotasStore;
    const {loadCoursesL,} = CuotasStore;
    const {loadEditions2,} = CuotasStore;
    const {loadTransXTipoCta,} =CuotasStore;

   
    let contador = 0
 

    const [CuotasMod, setCCTipoDeDocumento] = useState<CuotasModFormValues>(new CuotasModFormValues());

    const validationSchema = Yup.object({
        catCursoId: Yup.string().required('Obligatorio'),
        catEdicionesId: Yup.string().required('Obligatorio'),
        monto: Yup.number().required('Obligatorio'),
        // codigoTipoCuenta: Yup.number().required('Obligatorio'),
        codigoTipoTransaccion: Yup.string().required('Obligatorio'),        
                        
       
    })  



    
    
    let TiposTransXCta:object[]=[];
   
 

    let ActividadAcademica:object[]=[];

    let ediciones:object[]=[];

    function handleFormSubmit(CuotasMod : CuotasModFormValues) {
        let date: Date = new Date();
        const valorInput = (document.getElementById("check") as HTMLInputElement).checked;
        if(valorInput == true){
            let newCuotas:CuotasMod = {
                id: 0,               
                catCursoId: CuotasMod.catCursoId,
                catEdicionesId: CuotasMod.catEdicionesId,
                monto: CuotasMod.monto,          
                codigoTipoCuenta: "0",
                codigoTipoTransaccion: CuotasMod.codigoTipoTransaccion,
                fechaCobroProgramado: date,
                aplicaenInscripcion: "SI",
                procesoCargosAplicado: "NO",
                fechaRegistro: date,           
                usarioRegistra: "0",                  
               
                           
            };
    
            createCuotasMod(newCuotas).then(() => {
            toast.success("Se a guardado correctamente.")
            modalStore.closeModal()
            });
    

        }else{
            let newCuotas:CuotasMod = {
                id: 0,
               
                catCursoId: CuotasMod.catCursoId,
                catEdicionesId: CuotasMod.catEdicionesId,
                monto: CuotasMod.monto,          
                codigoTipoCuenta: "0",
                codigoTipoTransaccion: CuotasMod.codigoTipoTransaccion,
                fechaCobroProgramado: CuotasMod.fechaCobroProgramado,
                aplicaenInscripcion: "NO",
                procesoCargosAplicado: "NO",
                fechaRegistro: date,           
                usarioRegistra: "0",                  
               
                           
            };
            
            createCuotasMod(newCuotas).then(() => {
            toast.success("Se a guardado correctamente.")
            modalStore.closeModal()
            });
    
        }
       
       
    }
   
    loadCoursesL().then(function(result){
        result.forEach((element)=>{
        ActividadAcademica.push({text:element.nombre,value:element.id});
       
        })
        })

    
      
    var fun1 = () => {

      
         if(valor()){
                 
            
             ediciones=[]
            loadEditions2(valor()).then(function(result){
             result.forEach((element)=>{
               ediciones.push({text:element.fechas, value:element.id});
                   
                })
         });
            
           TiposTransXCta = [];
           loadTransXTipoCta(valor()).then(function(result){
                result.forEach((element)=>{
                    TiposTransXCta.push({text:element.descripcion,value:element.id});
                 })
             });
         }
      };


    
    // var fun2 = ()=>{
    //     if(valor()){
    //         TiposTransXCta = [];
    //         loadTransXTipoCta('45-001-12321').then(function(result){
    //             result.forEach((element)=>{
    //                 TiposTransXCta.push({text:element.descripcion,value:element.id});
    //             })
    //         });
    //     }
    // }

    const aplicar = () =>{
       
        const valorInput = (document.getElementById("check") as HTMLInputElement).checked;
        const divFecha = (document.getElementById("fecha") as HTMLInputElement);
        if(valorInput == false) {
            divFecha?.style.setProperty("display", "block")
        }else{
            divFecha?.style.setProperty("display", "none")
        }

        
    };

         

   if (CuotasStore.loadingInitial) return <LoadingComponent content='Cargando...' />

    return (
        
            <div className="pagina_formulario">
                <Segment className="contenedor_formulario">
                    <Formik validationSchema={validationSchema} 
                            enableReinitialize 
                            initialValues={CuotasMod} 
                            onSubmit={values => handleFormSubmit(values)}>
                        {({handleSubmit, isValid, isSubmitting, dirty}) => (
                            <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                <Header size='large' content='Nueva Cuota' style={{color:  "#538cbe", fontFamily: "Gotham"}} />
                                <br></br>
                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="Actividad Académica" />
                                    <MySelectInputEdiciones name='catCursoId' placeholder='' id="catCursoId" options={ActividadAcademica}  functionevent={fun1} />
                                    
                                </div><br></br>
                                <div>
                                    <Header size="small" content="Edición" />
                                    <MySelectInputEdiciones id="" name='catEdicionesId' placeholder='' options={ediciones} />
                                </div><br></br>
                                
                                
                                 {/* <div>
                                    <Header size="small" content="Tipo de Cuenta" />
                                    <MyTextInput name='codigoTipoCuenta' placeholder=''  />
                                </div> <br></br> */}
                                <div>
                                    <Header size="small" content="Tipo de Transaccion" />
                                                                     
                                    <MySelectInput id=" " name='codigoTipoTransaccion' placeholder='' options={TiposTransXCta} />
                                </div>  <br></br> 
                                <div>
                                    <Header size="small" content="Monto" />
                                    <MyTextInput name='monto' placeholder='' type="number"/>
                                </div>  <br></br>                          
                                
                                <div style={{display: "none", }} >
                                    <Header size="small" content="Aplica al inscribirse" />
                                  
                                   
                                </div>  <br></br>

                                <div>
                                    <Header size="small" content="Aplica al inscribirse" />
                                   
                                    <input id="check" type="checkbox" value="Valor1" onChange={aplicar}></input>
                                </div> <br></br> 
                             
                                <div id="fecha">
                                    <Header size="small" content="Fecha de Cobro Programado" />
                                    <MyDateInput name='fechaCobroProgramado' placeholderText='' dateFormat='dd/MM/yyyy' />
                                </div>                                                               
                              
                                <br></br>
                                <div>
                                    <Button
                                        loading={loading} 
                                        type='submit' 
                                        content='Guardar' 
                                        style={{backgroundColor: "#15b3e8", color: "white"}}/>
                                       
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Segment>
        </div>
    )
})
